
import React from 'react';
import { Button } from '@/components/ui/button';

interface EmptyPlaceholderProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

export const EmptyPlaceholder: React.FC<EmptyPlaceholderProps> = ({
  title,
  description,
  icon,
  children
}) => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-6 space-y-4">
      {icon && <div className="mb-4">{icon}</div>}
      <h3 className="text-xl font-semibold">{title}</h3>
      <p className="text-muted-foreground">{description}</p>
      {children && (
        <div className="mt-4">
          {children}
        </div>
      )}
    </div>
  );
};
